import apiClient from '../api/axiosConfig';
import { UploadComprobanteResponse, VentaResponse } from "../../types/api.types";
import { ENDPOINTS } from '../api/endpoints';

export const ventasService = {
    getVenta: async (pedidoId: number): Promise<VentaResponse> => {
        try {
            const response = await apiClient.get(ENDPOINTS.VENTAS.GET_BY_PEDIDO_ID(pedidoId));
            return response.data;  
        } catch (error) {
            console.log(error);
            const venta: VentaResponse= {pedidoId: 0, estadoId:1 }
            return venta;
        } 
    },

    uploadComprobante: async (
        pedidoId: number,
        files: File[]        
    ): Promise<UploadComprobanteResponse> => {
        try {
            const formData = new FormData();
            formData.append("pedidoId", pedidoId.toString());
            files.forEach((file) => {
                formData.append("files", file);
            });

            const response = await apiClient.post(
                ENDPOINTS.VENTAS.UPLOAD_COMPROBANTE,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            return response.data;
        } catch (error: any) {
            console.error("Error uploading comprobante:", error);
            if (error.response?.data) {
                return error.response.data;
            }
            return {
                success: false,
                message: "Error al cargar el comprobante. Por favor intente nuevamente."
            };
        }
    }
};